import { render } from "./NieuwsView.vue?vue&type=template&id=16a7d8d4"
import script from "./NieuwsView.vue?vue&type=script&lang=js"
export * from "./NieuwsView.vue?vue&type=script&lang=js"

import "./NieuwsView.vue?vue&type=style&index=0&id=16a7d8d4&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__